import { Component, OnInit } from '@angular/core';
import { Editor, Toolbar, toDoc, toHTML } from 'ngx-editor';
import { FormGroup, FormBuilder, FormControl, NgForm, Validators } from '@angular/forms';
import { NotificationService } from 'src/app/Service/notification.service';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { OtherService } from 'src/app/Service/other.service';
import axios from 'src/app/Service/axios';

declare let $: any;


@Component({

  selector: 'app-trip-news',

  templateUrl: './trip-news.component.html',

  styleUrls: ['./trip-news.component.css']

})

export class TripNewsComponent implements OnInit {

  lst_News: any = [];

  editor!: Editor;

  htmlContent: string = '';

  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  mdl_News: FormGroup = this.FormBuilder.group({

    iSystemUser: new FormControl(this.gurdService.decrypt(localStorage.getItem('ID')!)),

    strSession: new FormControl(this.gurdService.decrypt(localStorage.getItem('Session')!)),

    strTitle: new FormControl('', Validators.required),

    strContent: new FormControl('', Validators.required),

    strImage: new FormControl('', Validators.required),

    strDateTime: new FormControl({ value: '', disabled: false }),

    strValidateDateAndTime: new FormControl('', Validators.required),

    bImportant: new FormControl(false),

    b4Driver: new FormControl(true),

    bArchive: new FormControl(false),

    iNews: new FormControl(''),

    indexNews: new FormControl('')

  })

  bEditMode: boolean = false;

  constructor(

    private _tooltip: NotificationService,

    private FormBuilder: FormBuilder,

    private gurdService: GurdServiceService,

    private _otherService: OtherService,

  ) { }

  ngOnInit(): void {

    this.getNews()

    this.editor = new Editor();

  }

  ngOnDestroy(): void {

    this.editor.destroy();

  }

  async openModal(isEdit: boolean = false, item: any = {}, index: number = -1) {

    // اگر در حالت ثبت بود

    if (!isEdit) {

      this.mdl_News.patchValue({

        strTitle: '',

        strContent: '',

        strImage: '',

        strValidateDateAndTime: '',

        bImportant: false,

        b4Driver: true,

        bArchive: false,

        iNews: '',

        indexNews: ''

      })

      this.bEditMode = false;

      $("#News_Modal").modal('show');


    }

    // اگر در حالت ویرایش بود

    else {

      this.mdl_News.controls['iNews'].setValue(item.iNews)

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(`News_Info`, this._otherService.stringNumberToNumber(this.mdl_News.value))).data.toString());

      this._otherService.nonespinner();

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      Object.keys(res[0]).forEach(key => {

        this.mdl_News.get(key)?.setValue(res[0][key])

      })

      this.mdl_News.get('indexNews')?.setValue(index);

      this.bEditMode = true;

      $("#News_Modal").modal('show');

    }

  }

  onUpload(event: any) {

    const file = event.target.files[0];

    const reader = new FileReader();

    reader.readAsDataURL(file);

    reader.onload = () => {

      let uploaded;

      uploaded = reader.result as string;

      let parts = uploaded.split(',');

      let strImage = parts[1];

      uploaded = strImage;

      this.mdl_News.get('strImage')?.setValue(strImage);

    };
  }

  async getNews() {

    this._otherService.Showspinner();

    let res = JSON.parse((await axios.post(`News_ORG_List`, this._otherService.stringNumberToNumber(this.mdl_News.value))).data.toString());

    this._otherService.nonespinner();

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.lst_News = res;

  }

  async news_Submit() {

    if (this.mdl_News.invalid) return this._tooltip.showError('لطفا فرم را با دقت تکمیل کنید');

    if (this.mdl_News.get('strContent')?.value == "<p></p>") return this._tooltip.showError('متن خود را وارد کنید');

    if (typeof (this.mdl_News.get('strContent')?.value) != 'string') {

      this.mdl_News.get('strContent')?.setValue(toHTML(this.mdl_News.get('strContent')?.value))

    }

    //  اگر در حالت ثبت بود

    if (!this.bEditMode) {

      this._otherService.Showspinner();

      let res = JSON.parse((await axios.post(`News_Save`, this._otherService.stringNumberToNumber(this.mdl_News.value))).data.toString());

      this._otherService.nonespinner();

      if (res.iResult == 0) return this._tooltip.showError(res.strError);

      this.lst_News.push(res[0]);

      this._tooltip.showSuccess('با موفقیت ذخیره شد');

      $("#News_Modal").modal('hide');


    }

    // اگر در حالت ویرایش بود

    else {

      $.confirm({

        title: `آیا از ویرایش اطمینان دارید ؟`,

        content: '',

        type: 'blue',

        buttons: {

          ok: {

            text: "ویرایش",

            btnClass: 'btn-primary',

            keys: ['enter'],

            action: async () => {

              this._otherService.Showspinner();

              let res = JSON.parse((await axios.post(`News_Edit`, this._otherService.stringNumberToNumber(this.mdl_News.value))).data.toString());

              this._otherService.nonespinner();

              if (res.iResult == 0) return this._tooltip.showError(res.strError);

              this.lst_News[this.mdl_News.get('indexNews')?.value] = res[0];

              this._tooltip.showSuccess('با موفقیت ویرایش شد');

              $("#News_Modal").modal('hide');

            }

          },

          cancel: {

            text: "لغو",

          }

        }

      });

    }

  }

  removeNews(item: any, index: number) {

    $.confirm({

      title: `آیا از حذف اطمینان دارید؟ `,

      content: '',

      type: 'red',

      buttons: {

        ok: {

          text: "حذف",

          btnClass: 'btn-danger',

          keys: ['enter'],

          action: async () => {

            this.mdl_News.get('indexNews')?.setValue(index);

            Object.keys(item).forEach(key => {

              this.mdl_News.get(key)?.setValue(item[key])

            })

            this._otherService.Showspinner();

            let res = JSON.parse((await axios.post(`News_Delete`, this._otherService.stringNumberToNumber(this.mdl_News.value))).data.toString());

            this._otherService.nonespinner();

            if (res.iResult == 0) return this._tooltip.showError(res.strError);

            this.lst_News.splice(this.mdl_News.get('indexNews')?.value, 1)

            this._tooltip.showSuccess('با موفقیت حذف شد');

          }

        },

        cancel: {

          text: "لغو",

        }

      }

    });

  }


}
